<div class="px-2 md:px-3">
  <div>{{'PLAYER_PROFILE_FAQS_HELP_TEXT' | translate}}</div>
  <div class="text-lg pt-2">
    <a href="https://2k-dartsoftware.freshdesk.com/support/solutions/folders/103000649022" target="_blank">{{'FAQs' | translate}}</a>
  </div>

  @if (playerProfile && freshdeskSrc) {
    <p-divider align="left">
      <!--<div class="inline-flex align-items-center">
        <i class="pi pi-send mr-2"></i>
        <b>{{'CONTACT' | translate}}</b>
      </div>-->
    </p-divider>

    @if (!ticketSend) {
      <p>
        {{'PLAYER_PROFILE_CONTACT_TEXT' | translate}}
      </p>
    }
    <div class="pb-5">
      <p-panel class="white-panel">
        <ng-template pTemplate="header">
          <div class="flex align-items-center">
            {{'CONTACT' | translate}}
          </div>
        </ng-template>
        <!--<script>
        window.fwSettings={
          'widget_id':103000008865
        };
        !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()
        </script>
        <script type='text/javascript' src='https://euc-widget.freshworks.com/widgets/103000008865.js' async defer></script>-->
        <!--<script>
          window.fwSettings={
            'widget_id':103000008865
          };
          !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()
        </script>
        <script type='text/javascript' src='https://euc-widget.freshworks.com/widgets/103000008865.js' async defer></script>-->

        <!--<script type="text/javascript" src="https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.js"></script>-->
        <script type="text/javascript" src="https://euc-widget.freshworks.com/widgets/103000008865.js"></script>
        <style type="text/css" media="screen, projection">
          @import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css);
        </style>
        <iframe title="Feedback Form" class="freshwidget-embedded-form" id="freshwidget-embedded-form"
                [src]="freshdeskSrc" scrolling="no" height="580px" width="100%" frameborder="0">
        </iframe>
      </p-panel>
      <!-- ALT:

      <script>
	window.fwSettings={
	'widget_id':103000002687
	};
	!function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()
</script>
<script type='text/javascript' src='https://euc-widget.freshworks.com/widgets/103000002687.js' async defer></script>

-->
    </div>
  }

</div>
